// extracted by mini-css-extract-plugin
module.exports = {"block":"_1NXRD0kWdNW4BqB1qKAMg7"};